import { Skeleton, Space } from 'antd';
import React from 'react';
import { CSSProperties } from 'styled-components';

const AddressFormSkeleton: React.FC = () => {
  const fieldContainerStyles: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    maxWidth: '600px',
    marginTop: '20px',
  };

  const inputLabelStyles: CSSProperties = {
    marginBottom: '8px',
    width: '150px',
  };

  return (
    <React.Fragment>
      <div style={fieldContainerStyles}>
        {[1, 2].map((i) => (
          <div key={`select-${i}`}>
            <div style={inputLabelStyles}>
              <Skeleton.Input active={true} size='small' block />
            </div>
            <Skeleton.Input active={true} size='default' block style={{ height: '40px' }} />
          </div>
        ))}

        {[1, 2, 3].map((i) => (
          <div key={`input-${i}`}>
            <div style={inputLabelStyles}>
              <Skeleton.Input active={true} size='small' block />
            </div>
            <Skeleton.Input active={true} size='default' block style={{ height: '40px' }} />
          </div>
        ))}

        <Space align='center' style={{ marginTop: '10px' }}>
          <Skeleton.Avatar active={true} size='small' shape='circle' />
          <Skeleton.Input active={true} size='small' style={{ width: '220px' }} />
        </Space>

        <div style={{ marginTop: '10px' }}>
          <Skeleton.Button active={true} size='large' style={{ width: '180px' }} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddressFormSkeleton;
